import { render, staticRenderFns } from "./RiskProblemEchart.vue?vue&type=template&id=05d9222f&scoped=true"
import script from "./RiskProblemEchart.vue?vue&type=script&lang=js"
export * from "./RiskProblemEchart.vue?vue&type=script&lang=js"
import style0 from "./RiskProblemEchart.vue?vue&type=style&index=0&id=05d9222f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9222f",
  null
  
)

export default component.exports